const pages = [/* 'Email Address' */ 'Personal details', 'Terms and Conditions', 'Create User ID', 'Create Password'];

export default pages;